import { updateObject } from 'app-redux/utility'
import * as actionTypes from 'app-redux/actionTypes'

const initialState = {}

const setBilling = (state, { payload }) => {
  return updateObject(state, {
    ...payload,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_BILLING_POS:
      return setBilling(state, action)
    case actionTypes.CLEAR_BILLING_POS:
      return {}
    default:
      return state
  }
}

export default reducer
